import {z} from '@hono/zod-openapi';

export const mobileDeRefdataResponseSchema = z
  .object({
    values: z.array(z.string()).openapi({example: ['B8']}),
  })
  .openapi('MobileDeRefdataResponse');

export type MobileDeRefdataResponse = z.infer<typeof mobileDeRefdataResponseSchema>;
